// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Firebase    = require("firebase");
var Firebaseui  = require("firebaseui");
var Caml_module = require("bs-platform/lib/js/caml_module.js");

var User = /* module */[];

var UI = /* module */[];

var AuthProvider = /* module */[];

var AuthPersistence = /* module */[];

var Auth = /* module */[];

var Reference = Caml_module.init_mod([
      "/opt/build/repo/src/ffi/Firebase.re",
      62,
      6
    ], [[
        0,
        0,
        0
      ]]);

var DataSnapshot = Caml_module.init_mod([
      "/opt/build/repo/src/ffi/Firebase.re",
      66,
      6
    ], [[0]]);

Caml_module.update_mod([[
        0,
        0,
        0
      ]], Reference, Reference);

Caml_module.update_mod([[0]], DataSnapshot, DataSnapshot);

var Database = /* module */[
  /* Reference */Reference,
  /* DataSnapshot */DataSnapshot
];

var App = /* module */[];

var app = Firebase.initializeApp({
      apiKey: "AIzaSyD0Jnk8jtNfTSvfTUIO0V2uIP54M4gqM2s",
      authDomain: "mam-project-c6624am.firebaseapp.com",
      databaseURL: "https://mam-project-c6624am.firebaseio.com",
      projectId: "mam-project-c6624am",
      storageBucket: "mam-project-c6624am.appspot.com",
      messagingSenderId: "172272409562"
    });

var auth = app.auth();

var ui = new (Firebaseui.auth.AuthUI)(auth);

var db = Firebase.database(app);

exports.User            = User;
exports.UI              = UI;
exports.AuthProvider    = AuthProvider;
exports.AuthPersistence = AuthPersistence;
exports.Auth            = Auth;
exports.Database        = Database;
exports.App             = App;
exports.app             = app;
exports.auth            = auth;
exports.ui              = ui;
exports.db              = db;
/* Reference Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/ffi/Firebase.re
// module id = 56
// module chunks = 0